/**
 * @flow
 * @relayHash fb9eabc29ed5e56ad39bb7f0b656b2bb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EquipmentTable_viewer$ref = any;
export type EquipmentFieldType = "brandId" | "code" | "createdAt" | "createdBy" | "id" | "installationDate" | "ip" | "locationId" | "metadata" | "model" | "notes" | "photoUrl" | "productId" | "propertyId" | "serialNumber" | "servicePorts" | "status" | "type" | "updatedAt" | "updatedBy" | "%future added value";
export type OrderEnum = "ASC" | "DESC" | "%future added value";
export type EquipmentWhere = {|
  and?: ?$ReadOnlyArray<?EquipmentWhere>,
  or?: ?$ReadOnlyArray<?EquipmentWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  type?: ?ConditionInputType,
  status?: ?ConditionInputType,
  brandId?: ?ConditionInputType,
  model?: ?ConditionInputType,
  serialNumber?: ?ConditionInputType,
  ip?: ?ConditionInputType,
  servicePorts?: ?ConditionInputType,
  installationDate?: ?ConditionInputType,
  notes?: ?ConditionInputType,
  propertyId?: ?ConditionInputType,
  locationId?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  updatedAt?: ?ConditionInputType,
  updatedBy?: ?ConditionInputType,
  productId?: ?ConditionInputType,
  photoUrl?: ?ConditionInputType,
  metadata?: ?ConditionInputType,
  productName?: ?ConditionInputType,
  propertyName?: ?ConditionInputType,
  inRack?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type EquipmentTableQueryVariables = {|
  count: number,
  cursor?: ?string,
  orderBy?: ?$ReadOnlyArray<?EquipmentFieldType>,
  order?: ?OrderEnum,
  where?: ?EquipmentWhere,
|};
export type EquipmentTableQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EquipmentTable_viewer$ref
  |}
|};
export type EquipmentTableQuery = {|
  variables: EquipmentTableQueryVariables,
  response: EquipmentTableQueryResponse,
|};
*/


/*
query EquipmentTableQuery(
  $count: Int!
  $cursor: String
  $orderBy: [EquipmentFieldType]
  $order: OrderEnum
  $where: EquipmentWhere
) {
  viewer {
    ...EquipmentTable_viewer_2BlNTl
  }
}

fragment EquipmentTable_viewer_2BlNTl on Viewer {
  equipments(first: $count, after: $cursor, orderBy: $orderBy, order: $order, where: $where) {
    edges {
      node {
        id
        code
        type
        status
        model
        serialNumber
        ip
        servicePorts
        installationDate
        notes
        brandId
        propertyId
        locationId
        createdAt
        createdBy
        updatedAt
        updatedBy
        brand {
          name
          id
        }
        property {
          name
          id
        }
        location {
          name
          id
        }
        creator {
          name
          id
        }
        updater {
          name
          id
        }
        product {
          name
          family {
            name
            id
          }
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "[EquipmentFieldType]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "order",
    "type": "OrderEnum",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "EquipmentWhere",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v2 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v3 = {
  "kind": "Variable",
  "name": "where",
  "variableName": "where"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  (v5/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EquipmentTableQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EquipmentTable_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EquipmentTableQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "equipments",
            "storageKey": null,
            "args": (v4/*: any*/),
            "concreteType": "EquipmentConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "EquipmentEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Equipment",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "model",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "serialNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ip",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "servicePorts",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "installationDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "notes",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "brandId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "propertyId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "locationId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdBy",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedBy",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brand",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Brand",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "property",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Property",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "location",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Location",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "updater",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "product",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Product",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "family",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductFamily",
                            "plural": false,
                            "selections": (v7/*: any*/)
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "equipments",
            "args": (v4/*: any*/),
            "handle": "connection",
            "key": "EquipmentTable_equipments",
            "filters": [
              "orderBy",
              "order",
              "where"
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "EquipmentTableQuery",
    "id": null,
    "text": "query EquipmentTableQuery(\n  $count: Int!\n  $cursor: String\n  $orderBy: [EquipmentFieldType]\n  $order: OrderEnum\n  $where: EquipmentWhere\n) {\n  viewer {\n    ...EquipmentTable_viewer_2BlNTl\n  }\n}\n\nfragment EquipmentTable_viewer_2BlNTl on Viewer {\n  equipments(first: $count, after: $cursor, orderBy: $orderBy, order: $order, where: $where) {\n    edges {\n      node {\n        id\n        code\n        type\n        status\n        model\n        serialNumber\n        ip\n        servicePorts\n        installationDate\n        notes\n        brandId\n        propertyId\n        locationId\n        createdAt\n        createdBy\n        updatedAt\n        updatedBy\n        brand {\n          name\n          id\n        }\n        property {\n          name\n          id\n        }\n        location {\n          name\n          id\n        }\n        creator {\n          name\n          id\n        }\n        updater {\n          name\n          id\n        }\n        product {\n          name\n          family {\n            name\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '581df768741dc9f9623ea6ceebb50f1e';
module.exports = node;
